<template>
   <div class="home-page container">
        <div class="columns">
            <div class="column">
                <all-pos></all-pos>
            </div>
        </div>
    </div>
</template>

<script>

import AllPOs from './AllPOs'
import { mapState } from 'vuex';
import { mapMutations } from 'vuex';
import store from '../../store/store.js';

export default {
  name: 'SearchPage',
  components: {
    'all-pos': AllPOs,
  },
  data () {
    return {
    }
  },
  computed:{
    ...mapState([
      'currentPage'
    ]),
  },
  methods:{
    ...mapMutations([
        'updateCurrentPage'
    ]),
  },
  created(){
      store.commit('updateCurrentPage', 'search');
  }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.column{
    margin: 10px 10px 10px 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Search/SearchPage.vue